export const AUTH_MODE = (process.env.REACT_APP_AUTH_MODE || 'standalone').toLowerCase();

export const isStandalone = () => AUTH_MODE === 'standalone';
export const isPlatform = () => AUTH_MODE === 'platform';

const ssoOnly = String(process.env.REACT_APP_SSO_ONLY || '').trim().toLowerCase();
export const SSO_ONLY = ssoOnly === 'true' || ssoOnly === '1' || ssoOnly === 'yes';

export const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:5055/api').replace(/\/$/, '');

export const TOKEN_KEY = 'zTaskAuthToken';
export const USER_KEY = 'zTaskUserDetails';

export const getStoredToken = () => localStorage.getItem(TOKEN_KEY);
export const getStoredUser = () => {
    try {
        return JSON.parse(localStorage.getItem(USER_KEY) || 'null');
    } catch {
        return null;
    }
};

export const setSession = (token, user) => {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const clearSession = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
};

export const parseJwt = (token) => {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(jsonPayload);
    } catch {
        return null;
    }
};
